import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, BatteryWarning, Scale } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 px-6 md:px-12 bg-white/50" data-id="element-130">
      <div className="max-w-4xl mx-auto" data-id="element-131">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-132">
          <p className="text-xl md:text-2xl font-serif italic text-charcoal leading-relaxed border-l-4 border-sage pl-6" data-id="element-133">
            "Te despiertas un lunes por la mañana, eliges tu pantalón favorito
            y, por más que intentas aguantar la respiración, el botón
            simplemente no cierra. No es falta de voluntad. No es que estés
            comiendo 'demasiado'."
          </p>
          <p className="mt-6 text-lg text-gray-700" data-id="element-134">
            Es que las reglas de tu cuerpo cambiaron y nadie te dio el nuevo
            manual. Después de los 40, tu metabolismo no está roto,{' '}
            <strong data-id="element-135">está desincronizado.</strong>
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-136">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-8 text-center" data-id="element-137">
            El sistema actual no está diseñado para ti
          </h2>
          <p className="text-lg text-gray-700 mb-10 text-center max-w-3xl mx-auto" data-id="element-138">
            Si vives en Estados Unidos, estás rodeada de alimentos "light"
            llenos de químicos, estrés laboral constante y la presión de
            cuidarlo todo... menos a ti misma.
          </p>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-139">
            <div className="bg-cream p-6 rounded-2xl shadow-sm border border-sage/20" data-id="element-140">
              <div className="bg-sage/10 w-12 h-12 rounded-full flex items-center justify-center mb-4 text-sage" data-id="element-141">
                <AlertCircle size={24} data-id="element-142" />
              </div>
              <h3 className="font-bold text-xl mb-2" data-id="element-143">Neblina Mental</h3>
              <p className="text-gray-600" data-id="element-144">
                Vives con una neblina mental que no te deja enfocarte en tus
                tareas diarias.
              </p>
            </div>
            <div className="bg-cream p-6 rounded-2xl shadow-sm border border-sage/20" data-id="element-145">
              <div className="bg-sage/10 w-12 h-12 rounded-full flex items-center justify-center mb-4 text-sage" data-id="element-146">
                <BatteryWarning size={24} data-id="element-147" />
              </div>
              <h3 className="font-bold text-xl mb-2" data-id="element-148">Fatiga Extrema</h3>
              <p className="text-gray-600" data-id="element-149">
                Una fatiga abrumadora que te golpea sin falta todos los días a
                las 3:00 PM.
              </p>
            </div>
            <div className="bg-cream p-6 rounded-2xl shadow-sm border border-sage/20" data-id="element-150">
              <div className="bg-sage/10 w-12 h-12 rounded-full flex items-center justify-center mb-4 text-sage" data-id="element-151">
                <Scale size={24} data-id="element-152" />
              </div>
              <h3 className="font-bold text-xl mb-2" data-id="element-153">Inflamación</h3>
              <p className="text-gray-600" data-id="element-154">
                Esa inflamación abdominal que parece no irse ni aunque vivas a
                base de lechuga.
              </p>
            </div>
          </div>

          <p className="mt-10 text-center text-lg text-gray-700 italic font-medium" data-id="element-155">
            El sistema actual está diseñado para hombres jóvenes o atletas, no
            para la biología compleja de una mujer en su etapa de plenitud.
          </p>
        </motion.div>
      </div>
    </section>;
}